<script setup lang="ts">
  import type { PropType } from 'vue';
  import { useUseCaseList } from '@/composables/useUseCaseList';

  defineProps({
    localePath: {
      type: Function as PropType<(to: { name: string; params: { slug: string } }) => string>,
      required: true
    }
  });

  defineEmits(['close']);

  const { isLoading, useCases } = await useUseCaseList();
</script>

<template>
  <div class="services-more modal-container">
    <div class="services-more-modal">
      <div class="services-more-modal__wrapper">
        <div class="services-more-modal__header">
          <div class="services-more-modal__title">{{ $t('caseStudy.moreModal.title') }}</div>
          <a
            class="services-more-modal__close"
            @click.prevent.stop="$emit('close')" />
        </div>
        <div class="services-more-modal__content">
          <div
            v-if="isLoading"
            class="services-more-modal__loader" />
          <div v-else-if="!useCases?.length">{{ $t('caseStudy.moreModal.noMore') }}</div>
          <template v-else>
            <ServicesServiceListCard
              v-for="(useCase, i) in useCases"
              :key="i"
              :locale-path="localePath"
              :use-case-item="useCase" />
          </template>
        </div>
        <div class="services-more-modal__footer">
          <button
            class="services-more-modal__btn-close"
            @click.prevent.stop="$emit('close')">
            {{ $t('caseStudy.moreModal.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
